<template>
  <leftCenterRightContainer class="register-warp" :showRight="false" v-loading.fullscreen.lock="loading"
    :element-loading-text="loadingText">
    <div slot="left" class="register-left" :class="searchAll ? 'disabled' : ''">
      <div class="left-search">
        <el-input @input="doctorSearch" v-model="doctorSearchFrom.doctorName" placeholder="搜索医生"
          prefix-icon="el-icon-search" clearable></el-input>
      </div>
      <div class="calender-warp">
        <calendar ref="calendar" @changeMonth="changeMonth" @currenDate="getCurrenDate">
          <div slot="title" class="calender-title">理疗</div>
        </calendar>
      </div>
      <div class="left-doctor-list">
        <div class="register-btn" @click="openRegisterDialog">理疗预约</div>
        <div v-if="doctorList.length > 0" class="doctor-list-warp">
          <div :class="currenDoctor.doctorId == item.doctorId ? 'active list-item' : 'list-item'"
            v-for="item in doctorList" :key="item.schedulingItemId" @click="changeDoctor(item)">
            <div :class="currenDoctor.doctorId == item.doctorId ? 'active item-name' : 'item-name'">{{ item.doctorName
            }}
            </div>
            <div>总预约{{ item.bookingNum }}</div>
            <div>待执行{{ item.waitNum }}</div>
            <custom-button type="info" disabled size="mini"
              :style="{ 'opacity': item.status == 1 ? '1' : '0' }">停诊</custom-button>
          </div>
        </div>
        <div v-else class="noData">暂无排班</div>
      </div>
    </div>
    <div slot="center" class="register-right">
      <div class="right-top">
        <div class="top-left">
          <custom-button :disabled="searchAll" type="info" size="medium" style="width:100px"
            @click="toDay">查看今日</custom-button>
          <el-input class="ml10" @input="searchRegisterList" clearable v-model="patientSearchForm.searchValue"
            prefix-icon="el-icon-search" placeholder="患者姓名/手机号码"></el-input>
        </div>
        <div class="top-title">{{ currenDoctor.doctorName }} <span class="color6671 size16"
            v-show="currenDoctor.signinPolicy == 'signin_date'">(按签到顺序看诊)</span></div>
        <div class="top-right">
          <span v-show="currenDoctor.clinicName">坐诊诊室：</span>
          <span v-show="currenDoctor.clinicName" class="rehister-price">{{ currenDoctor.clinicName }}</span>
        </div>
      </div>
      <div class="right-content">
        <div class="content-top" :class="searchAll ? 'disabled' : ''">
          <el-radio-group size="mini" v-model="patientSearchForm.status" @input="statusChange">
            <el-radio-button v-for="item in statusList" :key="item.value" :label="item.value">{{ item.label }} ({{
              item.num
            }})</el-radio-button>
          </el-radio-group>
        </div>
        <div class="customTable scroll-loadmore" v-loadMore="getMoreList">
          <el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#F0F1F3' }" @cell-click="cellClick">
            <el-table-column prop="patientName" label="患者" min-width="120">
              <template slot-scope="{ row }">
                <div>
                  <span style="color: #1890FF;">{{ row.patientName }}</span>
                  <span v-if="row.source == 'platform-intermediary' && !(row.voucherCodes && row.voucherCodes.length > 0)" style="color: #A4AFBA;">(未核销)</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="sex" label="性别" width="60">
              <template slot-scope="{ row }">
                <div>{{ row.sex == 0 ? '男' : '女' }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="age" label="年龄" width="60"></el-table-column>
            <el-table-column prop="phone" label="手机号" width="130"></el-table-column>
            <el-table-column prop="status" label="状态">
              <template slot-scope="{ row }">
                <div :style="{color: [1, 6].includes(row.status) ? '#FE8F1F' : '#667182'}">{{ computedDict(row.status, statusList) }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="source" label="预约渠道" show-overflow-tooltip>
              <template slot-scope="{ row }">
                <div style="width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ sourceMap[row.source] }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="doctorName" label="治疗师"></el-table-column>
            <el-table-column prop="schedulingTime" label="就诊日期" width="120"></el-table-column>
            <el-table-column prop="reservationStartTime" label="预计就诊时间" width="120">
              <template slot-scope="{ row }">
                <div>{{ row.reservationStartTime }}-{{ row.reservationEndTime }}</div>
              </template>
            </el-table-column>
            <el-table-column v-if="patientSearchForm.status != '1'" prop="assemblyQueueNo" label="号数">
              <template slot-scope="{ row }">
                <div>{{ row.assemblyQueueNo || '-' }}</div>
              </template>
            </el-table-column>
            <el-table-column v-if="patientSearchForm.status != '1'" prop="checkinTime" label="签到时间">
              <template slot-scope="{ row }">
                <div>{{ row.checkinTime && new Date(row.checkinTime).Format('hh:mm') || '-' }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="clinicName" label="诊室"></el-table-column>
          </el-table>
        </div>
      </div>
      <phyRegister-dialog v-if="phyRegisterDialogObj.show" :show="phyRegisterDialogObj.show" @close="closeRegisterDialog" @openRedeem="openRedeem"></phyRegister-dialog>
      <registerPhyDetail-dialog v-if="detailDialogObj.show" :show="detailDialogObj.show" :dialogObj="detailDialogObj.info" @close="closeDetailDialog" @openRedeem="openRedeem" @print="openPrint"></registerPhyDetail-dialog>
      <MeiTuanRedeem ref="meiTuanRedeem" @submit="redeemSubmit"></MeiTuanRedeem>

      <printDialog
        ref="printDia"
        v-show="printMap.show"
        :printDialogShow="printMap.show"
        :id="printMap.id"
        :orderType="'22'"
        :printType="'1'"
        @closePrintPrescription="closePrintPrescription"
        @setPrintDiaShow="setPrintDiaShow"
        @printSuccess="printSuccess">
      </printDialog>
    </div>
  </leftCenterRightContainer>
</template>

<script>
import leftCenterRightContainer from '@/components/leftCenterRightContainer'
import { isEmptyArray, isNull, dictText, debounce, isNullObj, timeoutTimer, msgboxWarning } from '@/utils/validateBase'
import calendar from '@/components/calendar/index'
import { doctorPhySchedulingList, getRegisterPhyList, getRegisterPhyStatusNum, getPhyRegisterInfo } from '@/api/register'
import customTable from '@/components/customTable/customTable'
import { Utils } from '@/utils/utils'
import registerPhyDetailDialog from './component/registerPhyDetailDialog/registerPhyDetailDialog'
import phyRegisterDialog from './component/phyRegisterDialog/phyRegisterDialog'
import MeiTuanRedeem from '@/components/physio/MeiTuanRedeem'
import printDialog from '@/components/printDialog'

export default {
  components: {
    leftCenterRightContainer,
    calendar,
    customTable,
    phyRegisterDialog,
    registerPhyDetailDialog,
    MeiTuanRedeem,
    printDialog
  },
  data() {
    return {
      loading: false,
      loadingText: '请稍等',
      searchAll: false,
      sourceMap: {
        'applet': '小程序-已购买预约',
        'applet-quick': '小程序-未购买预约',
        'platform': '平台-已购买预约',
        'trilateral': '平台-未购买预约',
        'platform-intermediary': '三方平台',
        'weapp-doctor': '医生小程序-已购买预约',
        'weapp-doctor-quick': '医生小程序-未购买预约'
      },
      doctorSearchFrom: {
        doctorName: '',
        startTime: '',
        stopTime: '',
        deptId: this.$session.get('deptId')
      },//医生搜索参数
      doctorList: [{}],//医生列表
      currenDoctor: {
        doctorId: '',
        doctorName: ''
      },//当前选中医生
      patientSearchForm: {
        deptId: this.$session.get('deptId'),
        pageNum: 1,
        pageSize: 500,
        status: '1'
      },//查询患者列表条件查询
      statusList: [
        { label: '已预约', value: '1', num: 0,numLabel:'bookingNum' },
        { label: '已签到', value: '6', num: 0,numLabel:'checkInNum' },
        { label: '已执行', value: '3', num: 0,numLabel:'executedNum' },
        { label: '已结束', value: '5', num: 0,numLabel:'overNum' },
        { label: '已停诊', value: '4', num: 0,numLabel:'stopNum' },
        { label: '已取消', value: '2', num: 0,numLabel:'cancelNum' },
      ],
      tableData: [],
      phyRegisterDialogObj: {
        show: false
      },
      detailDialogObj: {
        show: false,
        info: {}
      },
      printMap: {
        show: false,
        id: ''
      }
    }
  },
  created() {

  },
  computed: {
    computedDict() {
      return function (val, list) {
        return isNull(val) ? '' : dictText(val, list)
      }
    }
  },
  methods: {
    doctorSearch: debounce(function () {
      this.getDoctorPhySchedulingList()
    }, 300),
    //切换上下月
    changeMonth(obj) {
      let divObj = this.$refs.calendar.$refs
      for (let key in divObj) { if (!isEmptyArray(divObj[key])) divObj[key][0].innerText = '' }
    },
    //获取当前激活的日期
    getCurrenDate(date) {
      this.currenDate = date;
      this.doctorSearchFrom.startTime = date
      this.doctorSearchFrom.stopTime = date
      this.getDoctorPhySchedulingList()
    },
    changeDoctor(item) {
      this.currenDoctor = item
      let divObj = this.$refs.calendar.$refs
      for (let key in divObj) { if (!isEmptyArray(divObj[key])) divObj[key][0].innerText = '' }
      this.getRegisterList();
      this.getRegisterStatusNum()
    },
    //获取医生理疗排班列表
    async getDoctorPhySchedulingList() {
      this.getRegisterStatusNum()
      let { code, rows } = await doctorPhySchedulingList(this.doctorSearchFrom);
      if (code == 200) {
        this.doctorList = rows;
        if (!isEmptyArray(rows)) {
          let bookingNum = 0;
          let waitNum = 0;
          // 计算每项数据的总和
          rows.forEach(item => {
            bookingNum = this.$bigNumber(bookingNum,'+', item.bookingNum);
            waitNum = this.$bigNumber(waitNum,'+', item.waitNum);
          })
          if (isNull(this.doctorSearchFrom.doctorName)) {
            this.doctorList.unshift({
              doctorId: '',
              status: '0',
              doctorName: '全部医生',
              bookingNum,
              waitNum,
              schedulingTime: rows[0].schedulingTime,
            })
          }
          this.currenDoctor = isNullObj(rows[0]) ? rows[0] : this.currenDoctor
          this.$nextTick(() => {
            let divObj = this.$refs.calendar.$refs
            for (let key in divObj) {
              if (!isEmptyArray(divObj[key])) divObj[key][0].innerText = ''
            }
          })
        } else {
          this.tableData = []
        }
        this.getRegisterList()

      }
    },
    toDay() {
      this.$refs.calendar.currentId = this.$moment().startOf('day').valueOf();
      this.$refs.calendar.init()
      this.getCurrenDate(this.$moment().format('YYYY-MM-DD'));

    },
    searchRegisterList: debounce(function () {
      if (isNull(this.patientSearchForm.searchValue)) {
        this.searchAll = false
      } else {
        this.searchAll = true
      }
      this.getRegisterList()
    }, 300),
    getMoreList() {
      let that = this
      if (this.isLoadMore && !this.isMore) {
        that.isMore = true
        that.patientSearchForm.pageNum += 1
        that.getRegisterList()
      }
    },
    async cellClick(row, column, cell, event) {
      let { code, data } = await getPhyRegisterInfo({ id: row.id })
      if (code == 200) {
        this.detailDialogObj.info = data
        this.detailDialogObj.show = true
      }
    },
    statusChange(val) {
      let obj = this.statusList.find(item => { return item.value == val })
      this.totalPriceTotal = obj.amount
      this.getRegisterList()
    },
    async getRegisterList() {
      this.tableData = []
      let params = {
        ...this.patientSearchForm,
        doctorId: this.currenDoctor.doctorId,
        startTime: this.currenDate,
        stopTime: this.currenDate,
      }
      if (this.searchAll) {
        let year = this.$refs.calendar.year
        params.startTime = this.$moment(this.currenDate).subtract(1, 'years').format('YYYY-MM-DD')
        params.stopTime = this.$moment(this.currenDate).add(1, 'month').format('YYYY-MM-DD')
        params.status = ''
      } else {
        params.startTime = this.currenDate
        params.stopTime = this.currenDate
      }
      let { code, rows } = await getRegisterPhyList(params)
      if (code == 200) {
        this.isLoadMore = Utils.lt(rows.length, this.patientSearchForm.pageSize) ? false : true
        this.isMore = false
        let total = 0
        rows.forEach(item => {
          total = this.$bigNumber(total, '+', item.price)
        })
        this.tableData = rows
      }
    },
    async getRegisterStatusNum() {
      let params = {
        deptId: this.$session.get('deptId'),
        doctorId: this.currenDoctor.doctorId,
        startTime: this.currenDate,
        stopTime: this.currenDate,
      }
      let { code, data } = await getRegisterPhyStatusNum(params);
      if (code == 200) {
        this.statusList.forEach(v=>{
          for (const key in data) {
            if(v.numLabel == key){
              v.num = data[key]
            }            
          }
        })
      }
    },
    openRegisterDialog() {
      this.phyRegisterDialogObj.show = true
    },
    closeRegisterDialog() {
      this.phyRegisterDialogObj.show = false
      this.getRegisterList()
    },
    closeDetailDialog(flag = false) {
      this.detailDialogObj.show = false
      if (flag) {
        this.getRegisterList()
        this.getRegisterStatusNum()
      }
    },
    openRedeem (id, schedulingTime) {
      this.$refs.meiTuanRedeem.open(id, schedulingTime)
    },
    redeemSubmit (reservationId) {
      this.closeDetailDialog(true)
      this.openPrint(reservationId)
    },
    openPrint (id) {
      this.printMap.id = id
      this.$nextTick(() => {
        this.$refs.printDia.useDefaultPrint()
      })
    },
    closePrintPrescription () {
      this.printMap.show = false
    },
    setPrintDiaShow () {
      this.printMap.show = true
    },
    printSuccess () {
      this.printMap.show = false
      this.getRegisterList()
      this.getRegisterStatusNum()
    }
  },
}
</script>

<style lang="less" scoped>
 .disabled{
    background: #fff !important;
    opacity: 0.5;
    cursor: not-allowed !important;
    pointer-events: none;
 }
.register-warp {
  .register-left {
    height: 100%;
    background: #FAFBFC;
    border-radius: 4px 0px 0px 4px;
    display: flex;
    flex-direction: column;
    border-right: 1px solid #EBEAEE;

    .left-search {
      padding: 12px 16px;
      border-bottom: 1px solid #EBEAEE;
    }

    .calender-warp {
      .calender-title {
        font-size: 14px;
      }

      // height: 270px;
      /deep/.calender-top {
        justify-content: space-between;
      }
    }

    .noData {
      color: #9AA0A8;
      font-size: 14px;
      margin-top: 112px;
      text-align: center;
    }

    .left-doctor-list {
      flex: 1;
      overflow: hidden;
      padding: 8px;
      border-top: 1px solid #EBEAEE;
      display: flex;
      flex-direction: column;

      .register-btn {
        height: 32px;
        line-height: 32px;
        text-align: center;
        border-radius: 4px;
        border: 1px solid #1890FF;
        font-weight: 400;
        font-size: 14px;
        color: #1890FF;
        cursor: pointer;
      }

      .doctor-list-warp {
        overflow: auto;
        margin-top: 12px;

        .list-item {
          display: flex;
          font-size: 12px;
          color: #667182;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 8px;
          height: 40px;
          padding: 10px 8px;
          box-sizing: border-box;

          &:hover {
            background: #F0F1F3;
            border-radius: 2px 2px 2px 2px;
          }

          .item-name {
            width: 70px;
            color: #1F2329;
            font-size: 14px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .active {
            color: #fff;
          }
        }
      }

      .active {
        background: #1890FF !important;
        color: #fff !important;
        border-radius: 2px 2px 2px 2px;
      }
    }
  }

  .register-right {
    height: 100%;
    display: flex;
    flex-direction: column;

    .right-top {
      display: flex;
      padding: 12px 16px;
      background: #fff;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #EBEAEE;

      .top-left {
        display: flex;
      }

      .top-title {
        color: #1F2329;
        font-size: 16px;
        font-weight: bold;
        padding-right: 157px;
      }

      .top-right {
        width: 150px;
        text-align: right;
        font-size: 14px;
        color: #667182;

        .rehister-price {
          color: #1F2329;
          font-weight: 500
        }
      }
    }

    .right-content {
      background: #fff;
      padding: 16px;
      height: 100%;
      box-sizing: border-box;
      overflow: hidden;
      display: flex;
      flex-direction: column;

      .content-top {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .top-right {
          font-size: 14px;
          color: #667182;

          .rehister-price {
            color: #1F2329;
            font-weight: 500
          }
        }
      }

      .customTable {
        margin-top: 8px;
        border: 1px solid #EBEAEE;
        border-bottom: none;
        height: 100%;
        overflow: auto;

        /deep/td {
          cursor: pointer;
        }
      }
    }
  }
}
</style>